import React, { useState, useEffect, useRef } from "react";
import Loading from "../../Loading/Loading";
import Filter from "./Filter/Filter";
import useSize from "../../useSize/useSize";
import Backend from "../../../Backend/Backend";
import moment from "moment";
import { toJpeg } from "html-to-image";
import toast from "react-hot-toast";

const fmt = require("indian-number-format");

const backend = await new Backend().init();

export default function SettlementSuper({ user_id }) {
  const windowSize = useSize();
  const elementRef = useRef(null);

  const [loading, setLoading] = useState(false);

  const [uUsername, setUsername] = useState(0);

  const [profitloss, setProfitLoss] = useState(0);
  const [commission, setCommission] = useState(0);

  const [rent, setRentShow] = useState(0);

  const [isDollar, setIsDollar] = useState(0);

  const [super_commission, setSuperCommission] = useState(0);
  const [super_booked, setSuperBooked] = useState(0);
  const [super_total, setSuperTotal] = useState(0);
  const [super_sharing, setSuperSharing] = useState(0);
  const [super_rent, setSuperRent] = useState(0);

  const [admin_commission, setAdminCommission] = useState(0);
  const [admin_booked, setAdminBooked] = useState(0);
  const [admin_total, setAdminTotal] = useState(0);
  const [admin_sharing, setAdminSharing] = useState(0);
  const [admin_rent, setAdminRent] = useState(0);

  const [date_start, setDate_Start] = useState(moment().startOf("week"));
  const [date_end, setDate_End] = useState(moment().endOf("week"));

  useEffect(() => {
    loadSettlement(moment().startOf("week"), moment().endOf("week"));
  }, []);

  const loadSettlement = (a, b) => {
    setDate_Start(a);
    setDate_End(b);
    setLoading(true);

    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      start: a ? a : date_start,
      end: b ? b : date_end,
      user_id: user_id,
    };

    backend.settlement_super(data).then((r) => {
      setLoading(false);
      if (r.error === "False") {
        setProfitLoss(r.booked);
        setCommission(r.commission);
        setRentShow(r.nse_cash || 0);
        setIsDollar(r.isDollar || 0);

        setSuperCommission(r.super_commission);
        setSuperBooked(r.super_booked);
        setSuperTotal(r.super_total);
        setSuperSharing(r.supersharing);
        setSuperRent(r.super_rent);

        setAdminCommission(r.admin_commission);
        setAdminBooked(r.admin_booked);
        setAdminTotal(r.admin_total);
        setAdminSharing(r.adminsharing);
        setAdminRent(r.admin_rent);

        setUsername(r.username);
      } else {
        if (r.logout === 1) {
          window.LogOut();
        } else {
          toast.error(r.message);
        }
      }
    });
  };

  const htmlToImageConvert = () => {
    if (!elementRef.current) return;
    toJpeg(elementRef.current, { cacheBust: false })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "Settlement.jpeg";
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => console.log(err));
  };

  const currency = isDollar === 1 ? "$" : "₹";

  const pnlAdminProfitTotal = parseFloat(
    Math.abs(admin_total) + parseFloat(admin_rent),
  ).toFixed(2);

  const pnlSuperProfitTotal = parseFloat(
    Math.abs(super_total) + parseFloat(super_rent),
  ).toFixed(2);

  const ProfitTotal = parseFloat(
    Math.abs(profitloss) + parseFloat(super_rent) + parseFloat(admin_rent),
  ).toFixed(2);

  const totalProfitRent = parseFloat(
    parseFloat(super_rent) + parseFloat(admin_rent),
  ).toFixed(2);

  const totalProfitTotal = parseFloat(
    parseFloat(profitloss) + parseFloat(commission),
  ).toFixed(2);

  const pnlAdminLossTotal = parseFloat(
    Math.abs(admin_total) - parseFloat(admin_rent),
  ).toFixed(2);

  const pnlSuperLossTotal = parseFloat(
    Math.abs(super_total) - parseFloat(super_rent),
  ).toFixed(2);

  const LossTotal = parseFloat(
    Math.abs(profitloss) - (parseFloat(super_rent) + parseFloat(admin_rent)),
  ).toFixed(2);

  const totalLossRent = parseFloat(
    parseFloat(super_rent) + parseFloat(admin_rent),
  ).toFixed(2);

  const totalLossTotal = parseFloat(
    parseFloat(profitloss) + parseFloat(commission),
  ).toFixed(2);

  return (
    <div
      style={{
        width: windowSize[0] - 100,
        height: windowSize[1] - 170,
        overflowY: "auto",
      }}
      className="bg-[var(--background)]"
    >
      {/* 🔹 Header */}

      <Filter settlement={loadSettlement} onDownload={htmlToImageConvert} />

      <div
        style={{
          height: windowSize[1] - 250,
        }}
        className="flex flex-col justify-center items-center"
      >
        <div
          ref={elementRef}
          style={{
            width: windowSize[0] / 2,
            height: windowSize[1] - 160,
          }}
          className="bg-[var(--background)] space-y-5 py-4 px-4 "
        >
          {/* 📋 Summary Header */}
          <div className="bg-[var(--background)] border-2 border-[var(--hover)] text-[var(--text)] rounded-xl shadow-sm text-center py-3">
            <div className="font-semibold text-[15px]">SUPER : {uUsername}</div>
            <div className="text-[12px] text-[var(--subtext)] mt-0.5">
              {moment(date_start).format("DD MMM YYYY")} →{" "}
              {moment(date_end).format("DD MMM YYYY")}
            </div>
          </div>

          {/* 📊 Main Data */}
          {loading ? (
            <div className="flex bg-[var(--background)] justify-center py-10">
              <Loading height={windowSize[1] - 370} />
            </div>
          ) : (
            <div className="space-y-5">
              {/* PROFIT SECTION */}
              {profitloss < 0 ? (
                <SectionCard title="PROFIT" color="green">
                  <Table
                    currency={currency}
                    rent={rent}
                    color="green"
                    rows={[
                      {
                        user: `ADMIN ${admin_sharing}%`,
                        pnl: pnlAdminProfitTotal,
                        brk: parseFloat(admin_commission).toFixed(2),
                        rent: parseFloat(admin_rent).toFixed(2),
                        total: parseFloat(admin_booked).toFixed(2),
                      },
                      {
                        user: `SUPER ${super_sharing}%`,
                        pnl: pnlSuperProfitTotal,
                        brk: parseFloat(super_commission).toFixed(2),
                        rent: parseFloat(super_rent).toFixed(2),
                        total: parseFloat(super_booked).toFixed(2),
                      },
                      {
                        user: "TOTAL",
                        pnl: ProfitTotal,
                        brk: parseFloat(commission).toFixed(2),
                        rent: totalProfitRent,
                        total: totalProfitTotal,
                      },
                    ]}
                  />
                </SectionCard>
              ) : (
                <SectionCard title="LOSS" color="red">
                  <Table
                    currency={currency}
                    rent={rent}
                    color="red"
                    rows={[
                      {
                        user: `ADMIN ${admin_sharing}%`,
                        pnl: pnlAdminLossTotal,
                        brk: parseFloat(admin_commission).toFixed(2),
                        rent: parseFloat(admin_rent).toFixed(2),
                        total: parseFloat(admin_booked).toFixed(2),
                      },
                      {
                        user: `SUPER ${super_sharing}%`,
                        pnl: pnlSuperLossTotal,
                        brk: parseFloat(super_commission).toFixed(2),
                        rent: parseFloat(super_rent).toFixed(2),
                        total: parseFloat(super_booked).toFixed(2),
                      },
                      {
                        user: "TOTAL",
                        pnl: LossTotal,
                        brk: parseFloat(commission).toFixed(2),
                        rent: totalLossRent,
                        total: totalLossTotal,
                      },
                    ]}
                  />
                </SectionCard>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ✅ Section Wrapper
function SectionCard({ title, color, children }) {
  const colorClass =
    color === "green"
      ? "text-[var(--buymeta)]"
      : color === "red"
        ? "text-[var(--sellmeta)]"
        : "text-[var(--primary)]";

  return (
    <div className="bg-[var(--background)] border-2 border-[var(--hover)] text-[var(--text)] rounded-xl p-4 shadow-sm">
      <div className={`font-semibold text-center mb-2 ${colorClass}`}>
        {title}
      </div>
      {children}
    </div>
  );
}

// ✅ Table Component
function Table({ rows, color, currency, rent }) {
  const pnlColor =
    color === "green"
      ? "text-[var(--buymeta)]"
      : color === "red"
        ? "text-[var(--sellmeta)]"
        : "text-[var(--text)]";

  if (!rows || rows.length === 0)
    return (
      <div className="text-center text-[12px] text-[var(--subtext)] py-2">
        No records found
      </div>
    );

  return (
    <div className="text-sm">
      {/* Header */}
      <div
        className={`grid ${
          rent > 0 ? "grid-cols-5" : "grid-cols-4"
        } text-[12px] text-[var(--subtext)] border-b border-[var(--hover)] pb-1 mb-2 font-medium`}
      >
        <span className="text-left">USER</span>
        <span className="text-right">P&L</span>
        <span className="text-right">BRK</span>
        {rent > 0 ? <span className="text-right">INT</span> : null}
        <span className="text-right">Total</span>
      </div>

      {/* Rows */}
      {rows.map((r, i) => {
        return (
          <div
            key={i}
            className={`grid ${
              rent > 0 ? "grid-cols-5" : "grid-cols-4"
            }  items-center text-[var(--text)] py-1.5 text-[13px] rounded-lg transition`}
          >
            {/* User */}
            <span className="font-medium text-left">{r.user}</span>

            {/* P&L */}
            <span
              className={`${pnlColor} font-semibold text-right text-[12px]`}
            >
              {fmt.format(Math.abs(r.total).toFixed(2))} {currency}
            </span>

            {/* BRK always red */}
            <span
              className={` ${
                r.brk > 0 ? "text-[var(--buy)]" : "text-[var(--sell)]"
              }  font-semibold text-right text-[12px]`}
            >
              {fmt.format(Math.abs(r.brk).toFixed(2))} {currency}
            </span>

            {rent > 0 ? (
              <span className="text-[var(--buy)] font-semibold text-right text-[12px]">
                {fmt.format(Math.abs(r.rent).toFixed(2))} {currency}
              </span>
            ) : null}

            {/* TOTAL = pnl + brk */}
            <span
              className={`${pnlColor} font-semibold text-right text-[12px]`}
            >
              {fmt.format(Math.abs(r.pnl))} {currency}
            </span>
          </div>
        );
      })}
    </div>
  );
}
